import React from "react";
import { DOMNode, attributesToProps, domToReact } from "html-react-parser";
import { Bleeder } from "../../components/Bleeder";
import { createReplacer } from "./Replacer";

const wrapBackgroundBleed = createReplacer({
  supports({ attribs, name }) {
    return name === "div" && "data-color" in attribs;
  },
  replace({ attribs, children }, options) {
    const props = attributesToProps(attribs);

    return (
      <Bleeder
        color={attribs?.["data-color"]}
        containerClassName="first:-mt-12"
      >
        <div {...props} className="content-bleed py-12 pb-12">
          {domToReact(children as DOMNode[], options)}
        </div>
      </Bleeder>
    );
  },
});

export default wrapBackgroundBleed;
